<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="body"><span epub:type="pagebreak" id="pageiii" title="iii"></span></p>
<div class="photo" id="_idParaDest-1">
<img alt="Embodied Hope: A Theological Meditation on Pain and Suffering, by Kelly M. Kapic" class="img100" src="Images/TP.jpg"/>
</div>
<p class="first"><br/></p>
<p class="firstcenter"><a href="http://www.IVPress.com/academic" target="_blank"><img alt="IVP Academic Imprint" src="Images/IVPAcademic.png"/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_titlepage.vue?72058b23